// # Financial Manager routes configuration
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ProtectedRoute from '../ProtectedRoute';

// # Import financial manager components
import FinancialManagerDashboard from '../../roles/employees/financial_manager/fin_man_dashboard';

// # Import shared components
import Profile from '../../general/profile/profile';
import Settings from '../../general/gen_pages/settings';

// # Financial Manager routes component
const FinancialManagerRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={
        <ProtectedRoute requiredRole="financial_manager">
          <FinancialManagerDashboard />
        </ProtectedRoute>
      } />
      <Route path="/profile" element={
        <ProtectedRoute requiredRole="financial_manager">
          <Profile />
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute requiredRole="financial_manager">
          <Settings />
        </ProtectedRoute>
      } />
    </Routes>
  );
};

export default FinancialManagerRoutes; 